import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Switch18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M13.5304 6.46966L9.00006 1.93933L4.46973 6.46966L5.53039 7.53032L9.00006 4.06065L12.4697 7.53032L13.5304 6.46966Z'
      fill='currentColor'
    />
    <path
      d='M4.46974 11.5303L9.00007 16.0607L13.5304 11.5303L12.4697 10.4697L9.00007 13.9393L5.5304 10.4697L4.46974 11.5303Z'
      fill='currentColor'
    />
  </Svg>
);

Switch18.displayName = 'Switch18';
export default Switch18;
